import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import ImageIcon from '@mui/icons-material/Image';
import VideocamIcon from '@mui/icons-material/Videocam';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ConversationLastMessage = ({ message, currentUserId }) => {
  const { t } = useTranslation();
  if (!message || message.type === 'system') return null;

  const sender =
    message.senderId === currentUserId ? `${t('chat.self_user_name')}: ` : '';
  const iconProps = {
    sx: { width: 16, height: 16 },
  };

  const { text, icon: Icon } = DISPLAY_TEXT_ICONS[message.type] ?? {
    text: message.body,
    icon: null,
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
      component="span"
    >
      {sender} {text} {Icon && <Icon {...iconProps} />}
    </Box>
  );
};

export default ConversationLastMessage;

const DISPLAY_TEXT_ICONS = {
  image: {
    text: 'Image',
    icon: ImageIcon,
  },
  video: {
    text: 'Video',
    icon: VideocamIcon,
  },
  audio: {
    text: 'Audio',
    icon: KeyboardVoiceIcon,
  },
};
